export function redirectLogin (from = window.location.href, { isLogout = false } = {}) {
  window.localStorage.removeItem('__soa_token__')
  window.localStorage.removeItem('__soa_email__')
  if (isLogout) {
    window.location.href = from
  } else {
    const forward = encodeURIComponent(from)
    window.location.href = `https://oa.cmcm.com/r/w?cmd=API_com.cm.cheetah.httpapi.login&forward=${forward}`
  }
}

export function verifyIsWb (email) {
  return email.trim().indexOf('wb_') === 0
}
